import { render } from "./views/ModulePay.html?vue&type=template&id=5b365ab9&external"
import script from "./ModulePay.vue?vue&type=script&lang=js"
export * from "./ModulePay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__